module.exports = __webpack_public_path__ + "img/bournemouth-fc.cbb6070c.png";